import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

import { GraphService } from '~/core/services/graph.service';
import { AppConfigService } from '~/core/services/appconfig.service';
import { AppSettingsService } from '~/core/services/appsettings.service';
import { environment } from '../../../../../environments/environment';

import { AppSettings } from '~/core/models/appsettings';

@Component({
    selector: 'header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})

export class HeaderComponent {
    @Input() title = "Wells Plug and Abandonment";
    @Output() setLayoutCssClass = new EventEmitter();
    @Output() reloadPage = new EventEmitter();

    public appSettings: AppSettings = new AppSettings();
    public env: string = "";
    public originalEnvFromConfig: string = ""; // Store original value from config.json
    public itemsClass = "";
    public initials: string = "";
    public showPhoto: boolean = false;

    constructor(
        private router: Router,
        private graphService: GraphService,
        private appConfigService: AppConfigService,
        private appSettingsService: AppSettingsService
    ) {
        console.log('[HeaderComponent] Constructor called');
        const configuredEnvironment = this.appConfigService.getConfig("environment");
        
        // Store the EXACT original value from config.json
        this.originalEnvFromConfig = configuredEnvironment; 
        // If config.json has empty string, use "localhost", otherwise use configured value or fallback to environment.name
        let resolvedEnvironment: string;
        if (configuredEnvironment === "") {
            resolvedEnvironment = "localhost";
            console.log('[HeaderComponent] Empty string detected, using "localhost"');
        } else {
            resolvedEnvironment = (configuredEnvironment || environment.name || "").toString().trim();
        }
        console.log('[HeaderComponent] Resolved environment (after fallback & trim):', resolvedEnvironment);
        
        if (resolvedEnvironment) {
            this.env = resolvedEnvironment.toLocaleUpperCase();
            console.log('[HeaderComponent] Final env value (uppercase):', this.env);
        } else {
            console.log('[HeaderComponent] No environment value set, this.env remains:', this.env);
        }
    }

    //*************************************************************************
    //  Component Life-Cycle Methods
    //*************************************************************************
    public async ngOnInit() {
        console.log('[HeaderComponent.ngOnInit] Component initialized, env value:', this.env);
        await this.getUserInfo();
    }

    //*************************************************************************
    //  Public Methods
    //*************************************************************************
    public navigateTo(url: string) {
        this.router.navigateByUrl(url);
    }

    //*************************************************************************
    //  Private Methods
    //*************************************************************************
    private async getUserInfo() {
        this.appSettings = await this.appSettingsService.getSettings();

        if (this.appSettings.user?.photo !== "") {
            this.showPhoto = true;
        } else {
            this.graphService.getUserPhoto().then((photo: any) => {
                this.appSettings.user.photo = photo;

                if (photo !== "") {
                    this.showPhoto = true;
                }
    
                this.appSettingsService.saveSettings(this.appSettings);
            });
        }
    }
}
